import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { loggables: Array }

  loggablesValueChanged() {
    this.dispatch("loggablesChanged", {
      detail: {
        loggables: this.loggablesValue
      }
    });
  }
}
